import { AxiosError, AxiosResponse } from 'axios';
import { AppError } from '~app/core/error/app-error';
import ToastError from './toast.vue';
import { useToast } from 'vue-toastification';

function _isHttpError(error: any): boolean {
  return error?.isAxiosError;
}

function _convertHttpError(error: AxiosError): AppError {
  const response: AxiosResponse = error.response;

  if (!response) {
    return new AppError(error.message, `${error.config.method.toUpperCase()} ${error.config.url}`);
  }

  const data = response.data || {};

  const name = `HTTP ${response.statusText}`;
  let message =
    data.error ||
    data.message ||
    data.title ||
    data.error_description ||
    `${name}: ${response.config?.url}`;

  if (data.errors) {
    message += '<pre class="small">' + JSON.stringify(data.errors, null, 2) + '</pre>';
  }

  return new AppError(name, message, response.status.toString());
}

export function createError(error: Error | any): AppError {
  if (_isHttpError(error)) {
    return _convertHttpError(error as AxiosError);
  }

  if (error instanceof AppError) {
    return error;
  }

  const { name = 'Unknown error', message = '', code = '' } = error || {};

  return new AppError(name, message, code);
}

export function errorHandler(error: Error) {
  const appError: AppError = createError(error);

  useToast().error(
    {
      component: ToastError,
      props: { error: appError },
    },
    { timeout: false, closeOnClick: false, draggable: false },
  );

  console.error(error); // eslint-disable-line no-console
}

export * from './routes';
